import { ScrollView, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ArrowLeft, Medal } from 'lucide-react-native';
import { AppButton } from '../components/ui/AppButton';
import { AppCard } from '../components/ui/AppCard';
import { AppText } from '../components/ui/AppText';
import { tokens } from '../theme/tokens';

const rankingItems = [
  { rank: 1, name: '林同学', score: '1280', label: '本周登顶榜' },
  { rank: 2, name: '陈同学', score: '1160', label: '连续学习' },
  { rank: 3, name: '你', score: '1090', label: '班级排名 第 3' },
];

export default function RankingPage() {
  const router = useRouter();

  return (
    <SafeAreaView style={styles.screen}>
      <View style={styles.header}>
        <AppButton
          label="我的"
          variant="ghost"
          onPress={() => router.back()}
          leftSlot={<ArrowLeft size={18} color={tokens.colors.primary} />}
          style={styles.backButton}
        />
        <View style={styles.headerCopy}>
          <AppText variant="title" weight="bold">
            本周登顶榜
          </AppText>
          <AppText variant="caption" tone="muted">
            RankingScreen 班级排名
          </AppText>
        </View>
      </View>

      <ScrollView contentContainerStyle={styles.content}>
        <AppCard style={styles.summaryCard}>
          <Medal size={26} color={tokens.colors.warning} />
          <View style={styles.summaryCopy}>
            <AppText variant="subtitle" weight="bold">
              班级排名 第 3
            </AppText>
            <AppText variant="body" tone="muted">
              距离上一名还差 70 分，完成今日计划可继续冲榜。
            </AppText>
          </View>
        </AppCard>

        {rankingItems.map((item) => (
          <AppCard key={item.rank} style={styles.rankCard}>
            <View style={styles.rankBadge}>
              <AppText variant="body" weight="bold" style={styles.rankText}>
                {item.rank}
              </AppText>
            </View>
            <View style={styles.rankCopy}>
              <AppText variant="body" weight="bold">
                {item.name}
              </AppText>
              <AppText variant="caption" tone="muted">
                {item.label}
              </AppText>
            </View>
            <AppText variant="subtitle" tone="primary" weight="bold">
              {item.score}
            </AppText>
          </AppCard>
        ))}
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: tokens.colors.background,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
    paddingHorizontal: tokens.layout.screenPadding,
    paddingTop: tokens.spacing.md,
    paddingBottom: tokens.spacing.sm,
  },
  backButton: {
    minHeight: 40,
    paddingHorizontal: tokens.spacing.sm,
  },
  headerCopy: {
    flex: 1,
  },
  content: {
    paddingHorizontal: tokens.layout.screenPadding,
    paddingTop: tokens.spacing.md,
    paddingBottom: tokens.spacing.xxl,
    gap: tokens.spacing.md,
  },
  summaryCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
    backgroundColor: tokens.colors.warningSoft,
  },
  summaryCopy: {
    flex: 1,
    gap: tokens.spacing.xs,
  },
  rankCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
  rankBadge: {
    width: 38,
    height: 38,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.primary,
  },
  rankText: {
    color: tokens.colors.white,
  },
  rankCopy: {
    flex: 1,
    gap: tokens.spacing.xs,
  },
});
